import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import useBrokenImageUrls from './useBrokenImageUrls';
import getValidImageUrls from './getValidImageUrls';
const useRemoveBrokenImageUrls = imageUrls => {
  const $ = _c(3);
  const brokenImageUrls = useBrokenImageUrls();
  let t0;
  if ($[0] !== brokenImageUrls || $[1] !== imageUrls) {
    t0 = getValidImageUrls(imageUrls, brokenImageUrls);
    $[0] = brokenImageUrls;
    $[1] = imageUrls;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const validImageUrls = t0;
  return validImageUrls;
};
export default useRemoveBrokenImageUrls;